import React, { useEffect, useState, useRef } from 'react';
import { injectFonts, T } from '../utils/fonts';

const Aurora = () => {
  useEffect(() => {
    const id = 'aurora-kf';
    if (document.getElementById(id)) return;
    const s = document.createElement('style');
    s.id = id;
    s.textContent = `
      @keyframes aurora1{0%{transform:translate(0,0) scale(1);opacity:.55}33%{transform:translate(8%,-12%) scale(1.15);opacity:.7}66%{transform:translate(-5%,8%) scale(.95);opacity:.5}100%{transform:translate(0,0) scale(1);opacity:.55}}
      @keyframes aurora2{0%{transform:translate(0,0) scale(1);opacity:.45}33%{transform:translate(-10%,6%) scale(1.1);opacity:.6}66%{transform:translate(7%,-9%) scale(1.05);opacity:.4}100%{transform:translate(0,0) scale(1);opacity:.45}}
      @keyframes aurora3{0%{transform:translate(0,0) scale(1.05);opacity:.4}50%{transform:translate(6%,10%) scale(.9);opacity:.6}100%{transform:translate(0,0) scale(1.05);opacity:.4}}
      @keyframes shimmer{0%{background-position:-200% center}100%{background-position:200% center}}
      @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
      @keyframes cardIn{from{opacity:0;transform:translateY(32px) scale(0.97)}to{opacity:1;transform:translateY(0) scale(1)}}
      @keyframes borderSlide{0%{background-position:200% 0}100%{background-position:-200% 0}}
    `;
    document.head.appendChild(s);
  }, []);
  return (
    <div style={{position:'fixed',inset:0,overflow:'hidden',pointerEvents:'none',zIndex:0,filter:'blur(80px)'}}>
      <div style={{position:'absolute',width:'70vw',height:'70vw',maxWidth:900,maxHeight:900,borderRadius:'50%',background:'radial-gradient(circle,rgba(99,102,241,.55) 0%,rgba(139,92,246,.3) 50%,transparent 70%)',top:'-20%',left:'-10%',animation:'aurora1 14s ease-in-out infinite'}}/>
      <div style={{position:'absolute',width:'65vw',height:'65vw',maxWidth:800,maxHeight:800,borderRadius:'50%',background:'radial-gradient(circle,rgba(6,182,212,.5) 0%,rgba(16,185,129,.25) 50%,transparent 70%)',bottom:'-10%',right:'-10%',animation:'aurora2 18s ease-in-out infinite'}}/>
      <div style={{position:'absolute',width:'55vw',height:'55vw',maxWidth:700,maxHeight:700,borderRadius:'50%',background:'radial-gradient(circle,rgba(245,158,11,.35) 0%,rgba(239,68,68,.2) 50%,transparent 70%)',top:'30%',left:'35%',animation:'aurora3 22s ease-in-out infinite'}}/>
    </div>
  );
};

const SpotlightCard = ({ children, accentColor, animDelay, style }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x:'50%', y:'50%', visible:false });
  const onMove = (e) => { const r = ref.current.getBoundingClientRect(); setPos({ x:`${e.clientX-r.left}px`, y:`${e.clientY-r.top}px`, visible:true }); };
  const onLeave = () => setPos(p => ({ ...p, visible:false }));
  return (
    <div ref={ref} onMouseMove={onMove} onMouseLeave={onLeave}
      style={{ position:'relative', animation:`cardIn 0.6s ${animDelay}s both cubic-bezier(0.4,0,0.2,1)`, ...style }}>
      <div style={{
        position:'absolute', inset:0, borderRadius:20,
        background:`radial-gradient(320px circle at ${pos.x} ${pos.y}, ${accentColor}28 0%, transparent 65%)`,
        opacity: pos.visible ? 1 : 0, transition:'opacity 0.35s ease',
        pointerEvents:'none', zIndex:3,
      }} />
      {children}
    </div>
  );
};

const Section = ({ title, children, last }) => (
  <section style={{ marginBottom:last?0:32, paddingBottom:last?0:32, borderBottom:last?'none':'1px solid rgba(255,255,255,0.07)' }}>
    <h2 style={{ fontSize:'clamp(1.05rem,4vw,1.5rem)', color:T.godot, fontWeight:700, margin:'0 0 14px', fontFamily: T.fontDisplay }}>{title}</h2>
    {children}
  </section>
);

const P = ({ children, style }) => (
  <p style={{ fontSize:'clamp(0.88rem,3.5vw,1rem)', color:T.muted, lineHeight:1.8, marginBottom:12, fontFamily: T.fontBody, ...style }}>{children}</p>
);

const TermsOfService = () => {
  useEffect(() => { injectFonts(); }, []);

  return (
    <div style={styles.page} dir="rtl">
      <Aurora />
      <div style={styles.wrapper}>
        <header style={{ textAlign:'center', marginBottom:40, animation:'fadeUp 0.6s 0.1s both' }}>
          <h1 style={{
            fontSize:'clamp(1.8rem,7vw,3.2rem)', margin:'0 0 10px', fontWeight:700, letterSpacing:'-0.02em',
            fontFamily: T.fontDisplay,
            background:`linear-gradient(90deg,${T.text} 20%,#fff 40%,${T.muted} 60%,${T.text} 80%)`,
            backgroundSize:'200% auto', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text',
            animation:'shimmer 3.5s linear infinite',
          }}>תקנון ותנאי שימוש</h1>
          <p style={{ ...styles.meta, fontFamily: T.fontBody }}>עדכון אחרון: {new Date().toLocaleDateString('he-IL')}</p>
        </header>

        <SpotlightCard accentColor={T.godot} animDelay={0.1}>
          <div style={styles.card}>
            <div style={{
              height:3, width:'100%', marginBottom:24, borderRadius:'0 0 3px 3px',
              background:`linear-gradient(90deg, transparent 0%, ${T.godot} 30%, #8b5cf6 70%, transparent 100%)`,
              backgroundSize:'200% 100%', animation:'borderSlide 4s linear infinite',
            }} />
            <Section title="1. כללי">
              <P>ברוכים הבאים לאתר GoGameDev3D. תנאי שימוש אלה מהווים הסכם מחייב בינך לבין GoGameDev3D. השימוש באתר מהווה הסכמה מלאה לתנאים אלה.</P>
            </Section>
            <Section title="2. שירותי האתר">
              <P>אתר GoGameDev3D מספק מידע על קורסי פיתוח משחקים, תכנות ופיתוח אתרים תלת-ממדיים עבור ילדים ובני נוער. השירותים כוללים:</P>
              <ul style={styles.list}>{['מידע על קורסים והרשמה לקורסים','תוכן חינוכי ומדריכים','אפשרות ליצירת קשר ופניות','הצגת סילבוסים והורדת מסמכים'].map((t,i)=><li key={i} style={{...styles.li, fontFamily: T.fontBody}}>{t}</li>)}</ul>
            </Section>
            <Section title="3. רישום והרשמה לקורסים">
              <P><strong>3.1 תהליך ההרשמה:</strong> הרשמה לקורסים נעשית באמצעות יצירת קשר טלפוני או דרך WhatsApp.</P>
              <P><strong>3.2 אישור הרשמה:</strong> ההרשמה תיחשב סופית רק לאחר קבלת אישור בכתב ותשלום המקדמה.</P>
              <P><strong>3.3 גיל המשתתפים:</strong> הקורסים מיועדים לילדים ובני נוער בגילאי 8-16. הרשמת משתתף מחייבת הסכמת הורה.</P>
            </Section>
            <Section title="4. תשלומים ומחירים">
              <P><strong>4.1 מחירי הקורסים:</strong> המחירים במטבע ישראלי (שקלים חדשים) ובתוספת מע"מ כדין.</P>
              <P><strong>4.2 שעות אקדמיות:</strong> כל שעת הוראה היא שעה אקדמית באורך 45 דקות.</P>
              <P><strong>4.3 תשלומים:</strong> התשלום יבוצע בהתאם לפירוט שיימסר במהלך תהליך ההרשמה.</P>
              <P><strong>4.4 החזרים:</strong> מדיניות ביטולים והחזרים תפורט בהסכם ההרשמה הספציפי.</P>
            </Section>
            <Section title="5. קניין רוחני">
              <P><strong>5.1 זכויות יוצרים:</strong> כל התכנים באתר שייכים ל-GoGameDev3D ומוגנים בזכויות יוצרים.</P>
              <P><strong>5.2 שימוש אסור:</strong> אין להעתיק, לשכפל, להפיץ, למכור או לעשות שימוש מסחרי בתכני האתר ללא אישור בכתב.</P>
            </Section>
            <Section title="6. התנהגות משתמשים">
              <ul style={styles.list}>{['לא להשתמש באתר למטרות בלתי חוקיות','לא להפיץ תוכן פוגעני, מטעה או זדוני','לא לנסות לפגוע באבטחת האתר','לא להעתיק או לגנוב תכנים'].map((t,i)=><li key={i} style={{...styles.li, fontFamily: T.fontBody}}>{t}</li>)}</ul>
            </Section>
            <Section title="7. הגבלת אחריות">
              <P><strong>7.1:</strong> האתר והשירותים ניתנים "כפי שהם". אנו לא מתחייבים שהאתר יהיה זמין בכל עת.</P>
              <P><strong>7.2:</strong> אנו עושים מאמצים להבטיח שהמידע מדויק, אך איננו אחראים לטעויות.</P>
            </Section>
            <Section title="8. שינויים בתנאי השימוש">
              <P>אנו שומרים את הזכות לעדכן את תנאי השימוש בכל עת. המשך שימוש לאחר פרסום השינויים מהווה הסכמה.</P>
            </Section>
            <Section title="9. דין וסמכות שיפוט">
              <P>תנאי שימוש אלה כפופים לדיני מדינת ישראל. כל מחלוקת תתברר בבתי המשפט המוסמכים במחוז תל אביב-יפו.</P>
            </Section>
            <Section title="10. יצירת קשר" last>
              <P>לשאלות או הבהרות:</P>
              <div style={styles.contactBox}>
                <P><strong>טלפון / WhatsApp:</strong> <a href="tel:054-944-7314" style={styles.link}>054-944-7314</a></P>
                <P style={{margin:0}}><strong>דוא"ל:</strong> <a href="mailto:GoGameDev3D@gmail.com" style={styles.link}>GoGameDev3D@gmail.com</a></P>
              </div>
            </Section>

            <div style={{ marginTop:32, paddingTop:20, borderTop:'1px solid rgba(255,255,255,0.07)', textAlign:'center' }}>
              <p style={{ ...styles.meta, fontStyle:'italic', fontFamily: T.fontBody }}>תנאי שימוש אלה תקפים החל מ-{new Date().toLocaleDateString('he-IL')}</p>
            </div>
          </div>
        </SpotlightCard>
      </div>
    </div>
  );
};

const styles = {
  page: { background:T.bg, minHeight:'100vh', padding:'clamp(16px,5vw,40px)', paddingTop:'clamp(80px,14vw,120px)', fontFamily:T.fontBody, position:'relative' },
  wrapper: { maxWidth:860, margin:'0 auto', position:'relative', zIndex:1 },
  meta: { fontSize:'clamp(0.8rem,3vw,0.9rem)', color:T.faint, margin:0 },
  card: { background:T.panel, backdropFilter:'blur(16px)', WebkitBackdropFilter:'blur(16px)', border:`1px solid ${T.line}`, borderRadius:20, padding:'clamp(20px,5vw,48px)', boxShadow:'0 8px 40px rgba(0,0,0,0.4)', overflow:'hidden' },
  list: { paddingRight:20, margin:'10px 0 12px', listStyle:'disc' },
  li:   { fontSize:'clamp(0.88rem,3.5vw,1rem)', color:T.muted, lineHeight:1.8, marginBottom:6 },
  contactBox: { background:'rgba(99,102,241,0.08)', border:'1px solid rgba(99,102,241,0.25)', borderRadius:12, padding:'clamp(14px,3.5vw,22px)', marginTop:12 },
  link: { color:T.indigoLight, fontWeight:600, textDecoration:'none' },
};

export default TermsOfService;
